module.exports = __webpack_public_path__ + "img/trading212.53a8c88d.png";